function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import PropTypes from 'prop-types';
import React from 'react';
import LabelBadge from "../LabelBadge/LabelBadge";

var FilterList = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterList, _React$Component);

  var _super = _createSuper(FilterList);

  function FilterList() {
    _classCallCheck(this, FilterList);

    return _super.apply(this, arguments);
  }

  _createClass(FilterList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          filters = _this$props.filters,
          maxWidth = _this$props.maxWidth,
          _onRemove = _this$props.onRemove;
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, filters.map(function (filter, i) {
        return (
          /*#__PURE__*/

          /* eslint-disable react/no-array-index-key -- No idea what filters is, and no guarantee there is a unique field present */
          React.createElement(LabelBadge, {
            className: "m-1",
            key: i,
            label: filter.label,
            maxWidth: maxWidth,
            onRemove: function onRemove() {
              return _onRemove(filter);
            },
            removable: filter.removable,
            value: filter.value
          })
        );
      }
      /* eslint-enable react/no-array-index-key */
      ));
    }
  }]);

  return FilterList;
}(React.Component);

export { FilterList as default };

_defineProperty(FilterList, "propTypes", {
  className: PropTypes.string,
  filters: PropTypes.array.isRequired,
  maxWidth: PropTypes.number,
  onRemove: PropTypes.func
});

_defineProperty(FilterList, "defaultProps", {
  maxWidth: 14
});

FilterList.displayName = "FilterList";